<script lang="ts">import MarkdownIt from "markdown-it";
import { onMount } from "svelte";
import { buildMarkdownItCtaRules, markdownItCtaPlugin } from "../plugins/markdown-it-cta-plugin";
import { cfgBrandTitle } from "@infinitro/config";
export let content;
export let returnType = "p";
export let brandName = cfgBrandTitle();
let renderedHtml = "";
const md = new MarkdownIt({
	html: true,
	breaks: true,
	linkify: true
});
md.use(markdownItCtaPlugin);
/*md.renderer.rules.cta = function (tokens, idx) {
const token = tokens[idx];
const content = md.utils.escapeHtml(token.content);

const attrs = token.attrs ?? [];
const action = attrs.find(([name]: string) => name === 'data-action')?.[1];

const tag = returnType;
const actionAttr = action ? ` data-action="${action}"` : '';

return `<${tag} class="markdown-cta" data-action-cta${actionAttr}>${content}</${tag}>`;
};*/
onMount(() => {
	content = content.replace(/%(domain|brand)%/g, `${brandName}`);
	renderedHtml = md.render(content);
});
</script>

{#if renderedHtml !== ''}
	<div class="markdown">
		{@html renderedHtml}
	</div>
{/if}

<style>
</style>
